import {
  INVENTORIZE_REVIEW_STATUSES,
  type InventorizeReviewStatus,
} from '@/features/inventorization/domain/review/inventorization-review-status';
import type { InventorizeReviewSection } from '@/features/inventorization/domain/review/inventorize-review-field-types';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export function reviewText(key: string, fallback: string, values?: Record<string, string | number>) {
  return translateInventoryText(`app.inventory.review.${key}`, fallback, values);
}

export function reviewSectionLabel(section: InventorizeReviewSection) {
  const sectionKeyByName: Record<InventorizeReviewSection, string> = {
    Identity: 'identity',
    Location: 'location',
    'Meter details': 'meterDetails',
    Note: 'note',
    Photos: 'photos',
    Registers: 'registers',
    'Remote reading': 'remoteReading',
  };

  return reviewText(`sections.${sectionKeyByName[section]}`, section);
}

export function reviewStatusLabel(status: InventorizeReviewStatus) {
  const fallbackByStatus: Record<InventorizeReviewStatus, string> = {
    [INVENTORIZE_REVIEW_STATUSES.accepted]: 'accepted',
    [INVENTORIZE_REVIEW_STATUSES.empty]: 'empty',
    [INVENTORIZE_REVIEW_STATUSES.manual]: 'manual',
    [INVENTORIZE_REVIEW_STATUSES.parsed]: 'parsed',
    [INVENTORIZE_REVIEW_STATUSES.unsure]: 'unsure',
    [INVENTORIZE_REVIEW_STATUSES.waived]: 'waived',
  };

  return reviewText(`statuses.${status}`, fallbackByStatus[status]);
}

export function reviewRegisterLabel(index: number) {
  return reviewText('register.label', 'Register {number}', { number: index + 1 });
}

export function reviewPhotoCount(count: number) {
  return count === 1
    ? reviewText('photoCount.one', '1 photo')
    : reviewText('photoCount.other', '{count} photos', { count });
}
